import { c as _c } from "react/compiler-runtime";
import { Field, FieldContent, FieldError, FieldLabel, InputGroup, InputGroupAddon, PhoneInput, Spinner } from '@repo/ui/components';
import { cn } from '@repo/ui/lib/utils';
import { ComponentProps, ReactNode } from 'react';
import { useFieldContext } from '../../lib/form-context.ts';
export const FormPhoneInput = t0 => {
  const $ = _c(48);
  let buttonClassName;
  let inputClassName;
  let label;
  let props;
  let required;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== t0) {
    ({
      buttonClassName,
      compact: t1,
      disabled: t2,
      inputClassName,
      isPending: t3,
      label,
      placeholder: t4,
      required,
      variant: t5,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = buttonClassName;
    $[2] = inputClassName;
    $[3] = label;
    $[4] = props;
    $[5] = required;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    buttonClassName = $[1];
    inputClassName = $[2];
    label = $[3];
    props = $[4];
    required = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
  }
  const compact = t1 === undefined ? true : t1;
  const disabled = t2 === undefined ? false : t2;
  const isPending = t3 === undefined ? false : t3;
  const placeholder = t4 === undefined ? "-" : t4;
  const variant = t5 === undefined ? "ghost" : t5;
  const field = useFieldContext();
  let t6;
  if ($[11] !== field.state.meta.errors) {
    t6 = field.state.meta.errors ?? [];
    $[11] = field.state.meta.errors;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const errors = t6;
  let t7;
  if ($[13] !== field.name || $[14] !== label || $[15] !== required) {
    t7 = label && typeof label === "string" ? <FieldLabel className={cn(required && "required gap-0.5")} htmlFor={field.name}>{label}</FieldLabel> : label;
    $[13] = field.name;
    $[14] = label;
    $[15] = required;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const t8 = compact ? variant : "ghost";
  let t9;
  if ($[17] !== buttonClassName) {
    t9 = cn("hidden", buttonClassName);
    $[17] = buttonClassName;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const t10 = props["data-testid"] ?? "form-phone-input";
  const t11 = isPending || disabled;
  const t12 = compact ? "placeholder:text-foreground focus:placeholder:text-muted-foreground h-6 rounded-s-md rounded-e-md border-none p-0 !text-base focus:px-3" : "rounded-s-md";
  let t13;
  if ($[19] !== inputClassName || $[20] !== t12) {
    t13 = cn(t12, inputClassName);
    $[19] = inputClassName;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  let t15;
  if ($[22] !== field) {
    t14 = () => field.handleBlur();
    t15 = value => field.handleChange(value ?? "");
    $[22] = field;
    $[23] = t14;
    $[24] = t15;
  } else {
    t14 = $[23];
    t15 = $[24];
  }
  let t16;
  if ($[25] !== field.state.value || $[26] !== placeholder || $[27] !== props || $[28] !== t10 || $[29] !== t11 || $[30] !== t13 || $[31] !== t14 || $[32] !== t15 || $[33] !== t9 || $[34] !== variant) {
    t16 = <PhoneInput buttonClassName={t9} className="flex-1" data-testid={t10} disabled={t11} inputClassName={t13} onBlur={t14} onChange={t15} placeholder={placeholder} value={field.state.value} variant={variant} {...props} data-sentry-element="PhoneInput" data-sentry-source-file="form-phone-input.tsx" />;
    $[25] = field.state.value;
    $[26] = placeholder;
    $[27] = props;
    $[28] = t10;
    $[29] = t11;
    $[30] = t13;
    $[31] = t14;
    $[32] = t15;
    $[33] = t9;
    $[34] = variant;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== isPending) {
    t17 = isPending && <InputGroupAddon align="inline-end"><Spinner className="text-muted-foreground" /></InputGroupAddon>;
    $[36] = isPending;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t16 || $[39] !== t17 || $[40] !== t8) {
    t18 = <InputGroup variant={t8} data-sentry-element="InputGroup" data-sentry-source-file="form-phone-input.tsx">{t16}{t17}</InputGroup>;
    $[38] = t16;
    $[39] = t17;
    $[40] = t8;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== errors) {
    t19 = <FieldError className="text-sm" errors={errors} data-sentry-element="FieldError" data-sentry-source-file="form-phone-input.tsx" />;
    $[42] = errors;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== t18 || $[45] !== t19 || $[46] !== t7) {
    t20 = <Field className="group gap-1" data-sentry-element="Field" data-sentry-component="FormPhoneInput" data-sentry-source-file="form-phone-input.tsx"><FieldContent data-sentry-element="FieldContent" data-sentry-source-file="form-phone-input.tsx">{t7}{t18}{t19}</FieldContent></Field>;
    $[44] = t18;
    $[45] = t19;
    $[46] = t7;
    $[47] = t20;
  } else {
    t20 = $[47];
  }
  return t20;
};